var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgShieldFilled = function SvgShieldFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillRule: "evenodd",
    d: "M12.717 2.258a12.76 12.76 0 0 0 7.27 2.987A1.103 1.103 0 0 1 21 6.348v4.811c0 4.853-3.55 9.4-8.412 10.761a2.199 2.199 0 0 1-1.175 0C6.55 20.561 3 16.01 3 11.158V6.346c0-.57.437-1.056 1.013-1.1a12.767 12.767 0 0 0 7.27-2.988 1.123 1.123 0 0 1 1.434 0Zm3.132 8.614a.75.75 0 0 0-1.06-1.06l-3.618 3.617-1.959-1.958a.75.75 0 0 0-1.06 1.06l2.489 2.49a.75.75 0 0 0 1.06 0l4.148-4.149Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgShieldFilled);
export default ForwardRef;